import * as React from 'react';
import { Box, Popper, Fade, ClickAwayListener } from '@mui/material';


/**
 * 浮動視窗
 * @param {string} id 唯一值
 * @param {component} button 按鈕/顯示/觸發區塊
 * @param {string} placement 顯示位置
 * @param {component} Content 內容
 * @param {object} props 內容參數
 */
export function SearchPopper({id, button, placement, Content, props}) {

  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  };

  const closeClick = () => {
    setOpen(false);
  }

  const canBeOpen = open && Boolean(anchorEl);
  const popperId = canBeOpen ? id : undefined;


  return (
    <ClickAwayListener onClickAway={closeClick}>
      <Box>

        <Box data-pointerdown='true' onClick={handleClick}>{button}</Box>

        <Popper
          id={popperId}
          open={open}
          anchorEl={anchorEl}
          transition
          placement={placement}
          style={{ zIndex: 1300 }}
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Box ml={-4} my={2}><Content {...props} closeClick={closeClick} /></Box>
            </Fade>
          )}
        </Popper>

      </Box>
    </ClickAwayListener>
  );
}